function checkHighlight(key){
    return key === "exterior" || key === "interior" || key === "video";
}

export default checkHighlight;